import LayoutBody from "../models/furniture/LayoutBody";
import LayoutSize from "../models/furniture/LayoutSize";
import api from "./config/axiosConfig";

const LAYOUTS_URL = "/viewer/layout_by_item/";
const SERVICE_URL = "/product/design";

export const getItemLayouts = async (
  itemId: number
): Promise<{ bodyLayouts: LayoutBody[]; sizeLayouts: LayoutSize[] }> => {
  const response = await api.get(`${LAYOUTS_URL}${itemId}/`);
  const data = response.data;
  return {
    bodyLayouts: data.layout_body.map(
      (body: Partial<LayoutBody>) => new LayoutBody(body)
    ),
    sizeLayouts: data.layout_size.map(
      (size: Partial<LayoutSize>) => new LayoutSize(size)
    ),
  };
};

export const getItemServiceQuestion = async (itemId: number): Promise<any> => {
  const response = await api.get(`${SERVICE_URL}/${itemId}/questions/`);
  return response.data;
};

export const getItemsServiceInfo = async (): Promise<any> => {
  const response = await api.get(`${SERVICE_URL}/info/`);
  return response.data;
};
